let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("db25y")).then(() => parcelRequire('6Yr1v'));